module.exports = __webpack_public_path__ + "img/1-2.0192cda7.png";